import axios from "axios";
import { Message } from 'element-ui';
import router from '@/router';

let config = {
    baseURL: "/api/v1",
    timeout: 5000,
    withCredentials: true
}

const instance = axios.create(config)

// 添加请求拦截器
instance.interceptors.request.use(function (config) {
    // 在发送请求之前做些什么
    return config;
}, function (error) {
    // 对请求错误做些什么
    return Promise.reject(error);
});

// 添加响应拦截器
instance.interceptors.response.use(function (response) {
    // 2xx 范围内的状态码都会触发该函数。
    // 对响应数据做点什么
    return response;
}, function (error) {
    const { message } = error
    const { status } = error.response
    if (status === 401) {
        // 授权失败操作
        router.push('/login')
        Message.error('权限校验失败，请重新登录')
        return
    } else if (status === 403) {
        // 无操作权限
        Message.error('无操作权限')
    } else if (status === 404) {
        // 404操作
        Message.error('无法找到该请求')
    } else if (message === 'Network Error') {
        // 后端接口连接异常
        Message.error('服务器异常')
    } else if (message.includes('timeout')) {
        // 系统接口请求超时
        Message.error('请求超时')
    } else if (message.includes('Request failed with status code')) {
        // 其他错误
        Message.error('服务器异常')
    }
    return Promise.reject(error.response)
});

export default instance